import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { counties } from "@/data/locations";

const TOP_CITIES = [
  { county: "huron-county", city: "bad-axe", name: "Bad Axe" },
  { county: "huron-county", city: "harbor-beach", name: "Harbor Beach" },
  { county: "huron-county", city: "sebewaing", name: "Sebewaing" },
  { county: "tuscola-county", city: "caro", name: "Caro" },
  { county: "tuscola-county", city: "cass-city", name: "Cass City" },
  { county: "sanilac-county", city: "sandusky", name: "Sandusky" },
];

const ServiceAreasStrip = () => {
  return (
    <section className="py-12 md:py-16 bg-muted/30 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 text-accent text-sm font-semibold mb-2">
              <MapPin className="h-4 w-4" />
              <span>Michigan's Thumb Region</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              Proudly Serving Local Businesses
            </h2>
          </div>
          <Link
            to="/locations"
            className="inline-flex items-center gap-2 text-accent font-medium hover:underline"
          >
            View all service areas
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-3 gap-3 mb-6">
          {counties.map((county) => (
            <Link
              key={county.slug}
              to={`/${county.slug}`}
              className="group p-4 rounded-xl bg-card border border-border hover:border-accent transition-all hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-foreground group-hover:text-accent transition-colors">
                    {county.name}
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    {county.cities.length} communities
                  </p>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-accent group-hover:translate-x-1 transition-all" />
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-wrap gap-2">
          <span className="text-sm text-muted-foreground mr-1">Popular cities:</span>
          {TOP_CITIES.map((c) => (
            <Link
              key={c.city}
              to={`/${c.county}/${c.city}`}
              className="text-sm px-3 py-1 rounded-full bg-background border border-border hover:border-accent hover:text-accent transition-all"
            >
              Digital marketing in {c.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasStrip;
